import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { EmailProviderType } from "../../../types/EmailProviderType";

type StateType = {
  list: Array<EmailProviderType>;
  current?: EmailProviderType;
};
const initialState: StateType = {
  list: [],
  current: undefined,
};

const emailProvidersSlice = createSlice({
  name: "emailProviders",
  initialState,
  reducers: {
    setList(state: StateType, action: PayloadAction<Array<EmailProviderType>>) {
      state.list = action.payload;
    },
    removeFromList(state: StateType, action: PayloadAction<number>) {
      state.list = state.list.filter((it) => it?.providerId !== action.payload);
    },
    addToList(state: StateType, action: PayloadAction<EmailProviderType>) {
      state.list = [action.payload, ...state.list];
    },
    setCurrent(state: StateType, action: PayloadAction<EmailProviderType | undefined>) {
      state.current = action.payload;
    },
    updateInList(state: StateType, action: PayloadAction<EmailProviderType | undefined>) {
      state.list = state.list.map(
        (it) => (it.providerId === action.payload?.providerId ? { ...it, ...action.payload } : it) as EmailProviderType,
      );
    },
  },
});

export const { setList, removeFromList, setCurrent, addToList, updateInList } = emailProvidersSlice.actions;
export default emailProvidersSlice.reducer;
